export default {
  selected: 'Selected',
  history: 'History',
  agree: 'ยอมรับ',
  disagree: 'ไม่ยอมรับ',
  pathologyReporting: 'Pathology Reporting',
  open: 'Open',
  contactLab: 'Contact Lab',
  signOut: 'Sign Out',
  sex: 'เพศ',
  age: 'อายุ',
  physician: 'Physician',
  pathologist: 'Pathologist',
  resident: 'Resident',
  residentName: 'Resident Name',
  ward: 'Ward',
  dob: 'DOB',
  hln: 'HLN',
  collectedDate: 'Collected Date',
  viewFullImageAll: 'View Full Image All',
  technicalApprove: 'Technical Approve',
  released: 'Released',
  changeStatusHistory: 'Change Status History',
  sentTo: 'Sent To',
  sampleInProcess: 'Sample In Process',
  slidePreparation: 'Slide Preparation',
  karyotype: 'Karyotype',
  pendingSignOut: 'Pending Sign Out',
  sendBack: 'Send Back',
  criticalResult: 'Critical Result',
  HSILorAbove: 'HSIL or Above',
  nonCriticalResult: 'Non Critical Result',
  undetermined: 'Undetermined',
  preliminaryReport: 'Preliminary Report',
  summaryClinicalInformation: 'SUMMARY CLINICAL INFORMATION',
  clinicalDiagnosis: 'Pathological Diagnosis',
  previous: 'Previous',
  grossDescription: 'Gross Description',
  selectTemplate: 'Select Template',
  messageBoxScale: 'ปรับขนาดกล่องข้อความ',
  remove: 'ลบ',
  revise: 'Revise',
  addendum: 'Addendum',
  Amendment: 'Amendment',
  microscopicDescription: 'Microscopic Description',
  immunofluorescence: 'Immunofluorescence',
  lightMicroscopicDiagnosis: 'Light Microscopic Diagnosis',
  electronMicroscopicFinding: 'Electron Gross Description',
  suggestion: 'SUGGESTION',
  internalcommunication: 'Internal communication',
  commentByAnotherPathologist: 'Recommendations by the consultant',
  ihcSpecialStaining: 'IHC Special Staining',
  provisionalAnatomicalDiagnosis: 'Provisional Anatomical Diagnosis',
  finalAnatomicalDiagnosis: 'Final anatomical diagnosis',
  postmortemInvestigation: 'Postmortem Investigation',
  discussion: 'Discussion',
  reference: 'Reference',
  bodyMeasurementAndOrganWeight: 'BODY MEASUREMENT AND ORGAN WEIGHT',
  parameter: 'Parameter',
  measuredValue: 'Measured value',
  normalRange: 'Normal range',
  weight: 'Weight (g)',
  lungRight: 'Lung Right (g)',
  crownHeelLength: 'Crown-Heel length (cm)',
  crl: 'CRL (cm)',
  liver: 'Liver (g)',
  headCircumference: 'Head circumference (cm)',
  adrenalGlandRight: 'Adrenal gland : Right (g)',
  adrenalGlandLeft: 'Adrenal gland : Left (g)',
  chestCircumference: 'Chest circumference (cm)',
  abdominalCircumference: 'Abdominal circumference (cm)',
  kidneyRight: 'Kidney : Right (g)',
  kidneyLeft: 'Kidney : Left (g)',
  innerCanthalDistance: 'Inner canthal distance (cm)',
  outerCanthalDistance: 'Outer canthal distance (cm)',
  testisRight: 'Testis : Right (g)',
  testisLeft: 'Testis : Left (g)',
  internippleDistance: 'Internipple distance (cm)',
  anteriorFontanelle: 'Anterior fontanelle (cm)',
  thymus: 'Thymus (g)',
  posteriorFontanelle: 'Posterior fontanelle (cm)',
  spleen: 'Spleen (g)',
  rightFootLength: 'Right foot length (cm)',
  leftFootLength: 'Left foot length (cm)',
  thyroidGland: 'Thyroid gland (g)',
  revisionApprove: 'Revision Approve',
  sent: 'ส่งแล้ว',
  pathoConsultRefer: 'Pathologist Consultant/Refer',
  receiptNo: 'Receipt_no',
  addPicture: 'เพิ่มรูปภาพ',
  transferPicture: 'Transfer Picture',
  figure: 'Figure',
  reportPart: 'Report Part',
  path: 'path',
  docID: 'Doc ID',
  pathoNo: 'Patho No',
  birthday: 'วันเกิด',
  doctor: 'หมอ',
  download: 'ดาวน์โหลด',
  consult: 'Consult',
  refer: 'Refer',
  doubleCheck: 'Double Check',
  preview: 'ตัวอย่าง',
  selectCritical: 'Please select critical type',
  blockSlideRemark: 'Block Slide Remark',
  selectConsultType: 'Please select consult type',
  blockRemark: 'Block Remark',
  viewAddendumRevise: 'View Addendum/Revise',
  report: 'รายงาน',
  selectOrderItem: 'Select Order Item',
  ihc: 'IHC',
  addOrderItem: 'Add Order Item',
  bethesdaSystem: 'Bethesda System',
  saveBlockQCPass: 'Save Block QC Pass',
  block: 'Block',
  additionClinical: 'ADDITION CLINICAL',
  previousTreatment: 'PREVIOUS TREATMENT',
  contraceptionMethod: 'Contraceptive',
  abortion: 'ABORTION',
  last: 'LAST',
  para: 'PARA',
  lmp: 'LMP',
  reportPDF: 'Report PDF',
  revision: 'Revision',
  orderName: 'Order Name',
  picture: 'รูปภาพ',
  recommendation: 'คำแนะนำ',
  interpretation: 'INTERPRETATION',
  metaphaseKaryotype: 'METAPHASE KARYOTYPE (ISCN)',
  metaphaseCountedAnalyzed: 'METAPHASE COUNTED AND ANALYZED',
  bandResolution: 'BAND RESOLUTION',
  bandTechnique: 'BAND TECHNIQUE',
  macroscopicFinding: 'MACROSCOPIC FINDING',
  typeSpecimen: 'TYPE OF SPECIMEN',
  clinicalInfo: 'Clinical Information',
  probeDes: 'PROBE DESCRIPTION',
  monosomicSignals: 'MONOSOMIC SIGNALS',
  trisomicSignals: 'TRISOMIC SIGNALS',
  breakageApartSignals: 'BREAKAGE APART SIGNALS',
  deletionSignals: 'DELETION SIGNALS',
  translocationSignals: 'TRANSLOCATION SIGNALS',
  normalSignals: 'NORMAL SIGNALS',
  totalCount: 'TOTAL COUNT',
  resultHybridization: 'RESULT OF HYBRIDIZATION',
  probeRequested: 'PROBE REQUESTED',
  disclaimers: 'Disclaimers',
  limitations: 'Limitations',
  method: 'Method',
  recommendations: 'ข้อแนะนำ',
  references: 'อ้างอิง',
  regionoLossheterozygosity: 'Region of Loss of heterozygosity',
  result: 'ผลลัพธ์',
  nomenclature: 'Nomenclature',
  clinicalAbnormalities: 'Clinical abnormalities',
  specimenType: 'Specimen type',
  arrayType: 'Array Type',
  caseSummary: 'Case Summary',
  noInjection: 'ไม่ฉีดยาศพ',
  embolism: 'ฉีดยาศพ',
  corpseInjectionServices: 'การให้บริการฉีดศพ',
  bodyDisposalDate: 'วันที่เวลาที่จำหน่ายศพ',
  corpseDealer: 'Corpse dealer',
  minute: 'นาที',
  Hour: '',
  dateRequestBody: 'วันที่ขอรับศพ',
  timeRequestBody: 'เวลาที่ขอรับศพ',
  dateTimeRequestBody: 'วันเวลาที่ขอรับศพ',
  idCard: 'เลขบัตรประชาชนผู้แจ้งขอรับศพ',
  relevant: 'เกี่ยวข้องเป็น',
  relativeName: 'ญาติผู้มารับศพชื่อ',
  instituteAutopsy: 'ส่งชันสูตรสถาบัน',
  agencyFoundation: 'หน่วยงาน / มูลนิธิ ที่มารับศพ',
  place: 'สถานที่ประกอบพิธีกรรมทางศาสนา',
  deathCertificatePlace: 'สถานที่ออกใบมรณบัตร',
  deathCertificateNumber: 'เลขที่ใบมรณบัตร',
  caseNumber: 'เลขที่คดี',
  causeOfDeath: 'สาเหตุการเสียชีวิต',
  mannerOfDeath: 'ลักษณะการเสียชีวิต',
  mannerOfDeathOther: 'โปรดระบุลักษณะการเสียชีวิต อื่นๆ',
  timeOfDeath: 'เวลาเสียชีวิต',
  dateOfDeath: 'วันที่เสียชีวิต',
  typeOfCorpse: 'ประเภทศพ',
  religion: 'ศาสนา',
  address: 'ที่อยู่',
  diagnosis: 'Diagnosis',
  heightMessageBox: 'ปรับความสูงกล่องข้อความ',
  saleOfCorpses: 'จำหน่ายศพ',
  microscopic: 'Microscopic',
  gross: 'Gross',
  refPatho: 'Ref Patho',
  addendumSummary: 'Addendum Summary',
  reviseSummary: 'Revise Summary',
  commentSuggestAddition: 'Comment & Suggestion Addition',
  commentSuggestion: 'Comment & Suggestion',
  category: 'Category',
  cytologicFinding: 'Cytologic Finding',
  microscopicFinding: 'Microscopic finding',
  CytopathologicalDiagnosis: 'Cytopathological Diagnosis',
  remainingSpecimen: 'Remaining specimen',
  staining: 'Staining',
  bodyCavityFluidPeritonealFluid: 'Body cavity fluid : Peritoneal fluid (mL)',
  heartRV: 'Heart RV (g)',
  heartLV: 'Heart LV (g)',
  bodyCavityFluidPericardialFluid: 'Body cavity fluid : Pericardial fluid (mL)',
  bodyCavityFluidLeftPleuralFluid: 'Body cavity fluid : Left pleural fluid (mL)',
  Brain: 'Brain (g)',
  hpvTestingResult: 'HPV testing result',
  hormonal: 'Hormonal',
  interpretationResult: 'Interpretation / result',
  generalCatergorization: 'General catergorization',
  specimenAdequacyAddition: 'Specimen Adequacy Addition',
  specimenAdequacy: 'Specimen Adequacy',
  site: 'Site',
  preparationTechnique: 'Preparation technique',
  siteAddition: 'Site addition',
  RightPleuralFluid: 'Body cavity fluid : Right pleural fluid (mL)',
  commentByAnotherPathologistHist: 'Recommendations by the consultant history',
  FrozenGrossDescription: 'Frozen Gross Description',
  FrozenDiagnosis: 'Frozen Diagnosis',
  PermanentGrossDescription: 'Permanent Gross Description',
  PathologicalDiagnosis: 'PathologicalDiagnosis',
  MessageCritical: 'กรุณาโทรแจ้งแพทย์เจ้าของไข้ภายใน 24 ชั่วโมง',
  NonNeoplasticFindings: 'Non-Neoplastic Findings',
  reasonForConsultation: 'Reason for Consultation',
  reasonForCancel: 'Reason for Cancellation',
  reasonForReject: 'Reason for Rejection',
  Concordance: 'Concordance',
  Discordance: 'Discordance',
  CommentsIFApplicable: 'Comments (if applicable)'
}
